<template>
    <div ref="image" class="hoverZoom" v-on:click="click" :style="{ 
            'cursor':`${!!canClick ? 'pointer' : 'auto'}`, 
            'background-image': `url(${src})`, 
            width: `${dwidth}px`, 
            height: `${dheight}px`, 
            // 'max-height': `${maxHeight}px`,
            // 'max-width': `${maxWidth}px` 
        }">
        <!-- <img :src="src" /> -->
        <slot></slot>
    </div>
</template>

<script>
    import store from '../assets/js/store.js';
    import utils from '../assets/js/utils.js';
    import _ from 'lodash';

    export default {
        name: 'hover-zoom',
        props: {
            src: {
                type: String,
                default: '',
            },
            width: {
                type: Number,
                default: 0
            },
            height: {
                type: Number,
                default: 0
            },
            canClick: {
                type: Boolean,
                default: false
            },
            fullHeight: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dwidth: 0,
                dheight: 0,
                maxHeight: 0,
                maxWidth: 0,
                loadedWidth: 0,
                loadedHeight: 0
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            click() {
                if(this.canClick) {
                    store.commit('setLightboxImage', this.src)
                }
            },
            handleResize() {
                this.calculateWidth(this.loadedWidth, this.loadedHeight)
            },
            calculateWidth(width, height) {
                this.dwidth = width;
                this.dheight = height;
                const propWidth = this.$props.width ? parseInt(this.$props.width) : width;
                const propHeight = this.$props.height ? parseInt(this.$props.height) : height;
                
                if (propHeight && propWidth) {
                    this.maxWidth = propWidth;
                    this.maxHeight = propHeight;
                } else if(propWidth) {
                    this.maxWidth = propWidth
                    this.maxHeight = (this.maxWidth * height) / width
                } else if(propHeight) {
                    this.maxHeight = propHeight
                    this.maxWidth = (this.maxHeight * width) / height
                } else {
                    this.maxHeight = propWidth * (height / width);
                    this.maxWidth = (this.maxHeight * width) / height
                }

                this.dwidth = this.maxWidth;
                this.dheight = this.maxHeight;

                this.$nextTick(function () {
                    // Code that will run only after the
                    // entire view has been re-rendered
                    if (!this.width && !this.height && this.$refs.image) {
                        const renderedWidth = this.$refs.image.getBoundingClientRect().width;
                        this.dheight = renderedWidth * (height / width);
                    }
                })

            },
            parseImage() {
                const img = new Image();
                const thisVar = this

                img.onload = function() {
                    // here you got the width and height
                    thisVar.calculateWidth(this.width, this.height)
                    thisVar.loadedWidth = this.width;
                    thisVar.loadedHeight = this.height;
                };

                img.src = this.src;
            }
        },
        mounted() {
            this.parseImage()
        },
        watch: {
            src: function() {
                this.parseImage()
            }
        }
    }
</script>

<style lang="scss" scoped>
    
</style>